export class OverlayService {
    constructor($document, $compile, $animate, $rootScope) {
        this.$document = $document;
        this.$compile = $compile;
        this.$animate = $animate;
        this.$rootScope = $rootScope;
        this.overlay = null;
    }

    open() {
        if (this.overlay) {
            return;
        }

        this.overlay = angular.element('<egto-overlay></egto-overlay>');
        var body = this.$document.find('body').eq(0);
        var after = body.children().eq(body.children().length - 1);
        var overlayScope = this.$rootScope.$new(true);
        this.$compile(this.overlay)(overlayScope);
        this.$animate.enter(this.overlay, body, after);
    }

    close() {
        if (!this.overlay) {
            return;
        }

        this.$animate.leave(this.overlay).then(() => { this._clearOverlay(); });
    }

    _clearOverlay() {
        this.overlay = null;
    }
}

OverlayService.$inject = ['$document', '$compile', '$animate', '$rootScope'];